/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import useForm from '../../hooks/useForm';
import Modal, { ModalHeader } from '../Modal';
import { editMembershipEnableHistoryList, getMemberships } from '../../apis/membership';
import { isEmpty } from '../../utils/lodashExtend';
import Form from '../Form';
import { toast } from '../../utils/toast';
import { get } from 'lodash';
/**
  * 회사별 상세 멤버십
  * 과거이력 확인 및 변경가능하도록
  */

const defaultForm = {};
const MembershipHistoryChange = ({ open, setOpen, selectedList, setSelectedList, submit }) => {
  const [fields, setFields] = useState([]);

  const [memberships, setMemberships] = useState([]);


  useEffect(() => {
    if (!isEmpty(memberships)) {
      const _fields = [
        {
          type: "select",
          title: "멤버십등급",
          options: {
            list: memberships
          },
          key: "membershipIdx"
        },
        {
          title: "메모",
          type: "textarea",
          key: "memo",

        }
      ];
      setFields(_fields);
      setForm({ membershipIdx: memberships[0].value, memo: "" });
    }
  }, [memberships]);

  const close = (e) => {
    if (e) {
      e.preventDefault();
    }
    setOpen(false);
    submit && submit();
    setSelectedList && setSelectedList([]);
  };

  const _submit = (_form) => {

    const params = {
      memo: _form.memo,
      membershipIdx: +_form.membershipIdx,
      companyIdx: selectedList.map(item => item.companyIdx),
    };
    editMembershipEnableHistoryList(params)
      .then(res => {
        toast.success("변경되었습니다.");
        close();
      });
  };

  const {
    form,
    originForm,
    errors,
    setForm,
    handleOnChange,
    handleSubmit,
  } = useForm(
    defaultForm,
    _submit,
    fields
  );


  useEffect(() => {
    if (!isEmpty(selectedList)) {
      getMemberships({})
        .then(res => {
          setMemberships(res.rows.map(item => ({ ...item, value: item.idx })));
        });
    }
  }, [open, selectedList]);


  const isDisabledSubmit = () => {
    return !(+form.membershipIdx !== +originForm.membershipIdx || form.memo !== originForm.memo);
  };
  return (
    <>

      <Modal
        isOpen={open && !isEmpty(selectedList)}
        close={close}
      >
        <ModalHeader>
          {`"${get(selectedList, "[0].name", "")}"${selectedList.length === 1 ? "" : `외 ${selectedList.length - 1}개`} 멤버십 정보 수정`}
        </ModalHeader>
        <div className="care-company-addsiteinfo">
          <div className="header-wrap pb-12">
            <ul className="header-tab">
              <li className="header-item">{form?.managerCompany?.name && (
                <span className="">
                  {`관리회사: ${form?.managerCompany?.name}`}
                </span>
              )}</li>
            </ul>
          </div>
        </div>

        <Form
          form={form}
          errors={errors}
          isRequiredShow={true}
          setForm={setForm}
          fields={fields}
          onChange={handleOnChange}
          submit={handleSubmit}
          submitText={"변경"}
          cancel={close}
          isDisabledSubmit={isDisabledSubmit}
        />

      </Modal>
    </>
  );
};

export default MembershipHistoryChange;